import { render, staticRenderFns } from "./comfirm_form.vue?vue&type=template&id=e5944714&"
import script from "./comfirm_form.vue?vue&type=script&lang=js&"
export * from "./comfirm_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports